export * from './authentication.service';
export { AuthenticationService as AuthService } from './authentication.service';
export * from './canonical.service';
export * from './main.service';
export * from './notification.service';
